import { Fade } from "react-awesome-reveal";
import type { AboutSectionCardProps } from '../store/types';

const AboutSectionCard = ({
    items,
    title,
    delay = 100
}: AboutSectionCardProps) => {
    const titleId = title
        ? `about-section-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`
        : undefined;

    return (
        <Fade triggerOnce delay={delay}>
            <section className="bg-light border-radius-25 p-4 mt-3" aria-labelledby={titleId}>
                <h2 id={titleId} className="fs-25 mb-4 text-red">
                    <span className="border-bottom black pb-1 fw-700">{title}</span>
                </h2>

                <div className="fw-600">
                    {items.map((item) => (
                        <article key={`${item.title}-${item.subtitle}`} className="mb-2">
                            <div className="d-flex">
                                <span className="text-red "><b>- </b></span>
                                <p className="pl-1"><span className="fw-700">{item.title}</span> {item.subtitle}</p>
                            </div>

                            {item.list?.length ? (
                                <ul className="mb-0">
                                    {item.list.flatMap((group, groupIndex) => {
                                        if (!group.title?.trim()) {
                                            return group.items.map((entry) => (
                                                <li key={`${item.title}-${item.subtitle}-plain-${groupIndex}-${entry}`}>
                                                    <p>{entry}</p>
                                                </li>
                                            ));
                                        }

                                        return (
                                            <li key={`${item.title}-${item.subtitle}-${group.title}-${groupIndex}`}>
                                                <span className="fw-600">{group.title}:</span>
                                                <ul className="mb-0">
                                                    {group.items.map((entry) => (
                                                        <li key={`${item.title}-${group.title}-${entry}`}>
                                                            <p>{entry}</p>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                        );
                                    })}
                                </ul>
                            ) : null}
                        </article>
                    ))}
                </div>
            </section>
        </Fade>
    );
};

export default AboutSectionCard;
